import axios from "axios";
import { ICompany } from "../types/companies";
const { API_BACKEND_HOST } = process.env;

const api = axios.create({
  baseURL: `${API_BACKEND_HOST}`,
});

interface ICreateParams {
  name: string;
  color: string;
  adminMemberId: string;
}

interface IUpdateParams {
  id: string;
  name: string;
  color: string;
  adminMemberId: string;
}

export const create = async (params: ICreateParams) => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await axios.post(
    `${API_BACKEND_HOST}${languageId}/v1/BusinessUnit`,
    {
      ...params,
    },
  );

  return data;
};

export const update = async (params: IUpdateParams) => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await axios.put(
    `${API_BACKEND_HOST}${languageId}/v1/BusinessUnit/${params.id}`,
    {
      ...params,
    },
  );

  return data;
};

export const toggleActive = async (id: string, active: boolean) => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await axios.patch(
    `${API_BACKEND_HOST}${languageId}/v1/BusinessUnit/${id}`,
    {
      active
    },
  );

  return data;
};

interface IGetCommitteePackagesResponse {
  name: string,
  createdDate: Date,
  changeDate?: Date,
  active: boolean,
  adminMemberId: string,
  adminMemberName: string,
  color: string,
  committeePackages: []
  companies: ICompany[]
}

export interface IBusinessUnit {
  id: string,
  name: string,
  color: string,
  active: boolean,
  committeePackages: {
    id: string;
    active: boolean;
    isAdmin: boolean;
    name: string;
    committees: {
      id: string; 
      name: string;
      activated: boolean;
    }[],
    groups: {
      id: string; 
      name: string;
      active: boolean;
    }[]
  }[]
}

export interface IBusinessUnitOption {
  id: string,
  name: string,
}

export interface IGetBusinessResponse {
  businessUnits: IBusinessUnit[];
}

export interface IGetBusinessOptionsResponse {
  businessUnits: IBusinessUnitOption[];
}

export const getById = async (businessId: string) => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await axios.get<IGetCommitteePackagesResponse>(
    `${API_BACKEND_HOST}${languageId}/v1/BusinessUnit/${businessId}`,
  );

  return data;
};

export const getAll = async (filters?: {name?: string; committeeId?: string}) => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await axios.get<IGetBusinessResponse>(
    `${API_BACKEND_HOST}${languageId}/v1/BusinessUnit`,
    {
      params: filters
    }
  );

  return data;
};

export const getBuOptions = async (filters?: {name?: string; committeeId?: string}) => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await axios.get<IGetBusinessOptionsResponse>(
    `${API_BACKEND_HOST}${languageId}/v1/BusinessUnit/options`,
    {
      params: filters
    }
  );

  return data;
};
